import {
  getList,
} from "@surya-digital/leo-ts-types";
import { RankingAnswerElementV1, RankingAnswerElementV1DTO } from "./rankingAnswerElementV1";

export interface RankingAnswerV1DTO {
  answers: RankingAnswerElementV1DTO[];
}

export class RankingAnswerV1 {
  readonly isRankingAnswerV1RankingAnswerV1: boolean = true;

  readonly answers: RankingAnswerElementV1[];


  constructor(
  answers: RankingAnswerElementV1[]
  ) {
    this.answers = answers;
  }

  static fromDTO(dto: RankingAnswerV1DTO): RankingAnswerV1 {
    const answers = getList<RankingAnswerElementV1DTO, RankingAnswerElementV1>(
      dto,
      "answers",
      RankingAnswerElementV1.fromDTO,
      InvalidRankingAnswerV1AnswersError
    );
    return new RankingAnswerV1(
      answers
    );
  }

  toDTO(): RankingAnswerV1DTO {
    const dto: RankingAnswerV1DTO = {
        answers: this.answers.map((e: RankingAnswerElementV1) => { return e.toDTO() })
    };
    return dto;
  }
  }

RankingAnswerV1.prototype.toString = function toString(): string {
  return `RankingAnswerV1(answers='${this.answers}')`;
};

export class InvalidRankingAnswerV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRankingAnswerV1Error";
  }
}
export class InvalidRankingAnswerV1AnswersError extends InvalidRankingAnswerV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRankingAnswerV1AnswersError";
  }
}
